import React from 'react'
import { Icon, Tooltip } from 'antd'
import Colors from '../../../themes/Colors'
import './helpIconStyle.css'

export const HelpIcon = ({secondary}) => {
  return secondary ? <Icon type="question-circle" theme="twoTone" twoToneColor={Colors.primary} style={{ fontSize: '18px'}} /> : <Icon type="question-circle" theme="filled" style={{ color: Colors.primary, backgroundColor: 'white', borderRadius: '50%', fontSize: '18px'}} />
}

const HelpTooltipIcon = ({ href, tooltip, secondary }) => {
  return (
    <Tooltip title={tooltip}>
      <div className="help-icon-container">
        <a href={href} target="_blank" rel="noopener noreferrer" className="help-icon-link">
          <HelpIcon secondary={secondary} />
        </a>
      </div>
    </Tooltip>
  )
}

export default HelpTooltipIcon